import React from "react";
import Hoc from "../../components/HOC";
import DocumentsForm from "../Documents";

const EmployeeStatus = () => {
  return (
    <DocumentsForm />
  )
}

export default Hoc(EmployeeStatus)
